import { Component, OnInit } from '@angular/core';
import { ApiService } from '../api.service';
import { Router } from '@angular/router';
import { HandlerService } from '../handler.service';
import { AuthService } from '../auth.service';
import { AppComponent } from '../app.component';
import { DomSanitizer } from '@angular/platform-browser';
import { Platform } from '@angular/cdk/platform';

@Component({
  selector: 'app-tag-category',
  templateUrl: './tag-category.component.html',
  styleUrls: ['./tag-category.component.scss'],
})
export class TagCategoryComponent {

  loader:boolean = true;
  category:any=[];
  search:any=[];
  filterLength;
  userObj;
  name;
  id;
  catArray:any=[];
  change: boolean = false;
  url;
  array =[];
  userCat:any=[]

  constructor(public service: ApiService,
    public router: Router,
    public handler: HandlerService,
    public auth: AuthService,
    public app: AppComponent,
     public santinzer: DomSanitizer,
      public platform: Platform) { }
  
      ionViewWillEnter(){        
        this.getCategory();
        
      }

      getCategory(){
        this.service.getOrgCategoryDetails().subscribe((res: any) => {
          this.category=res;    
        this.getProfile();
        this.loader=false;
        },
        err => {
          this.handler.err(err);
          this.loader = false;
        })
      }
  

      getProfile(){
        this.url = window.location.href;
        this.id = this.url.split('/').pop();
        this.service.getAddressById(this.id).subscribe(res => {
          this.userObj = res;   
          if(this.userObj.categories){      
            this.userObj.categories.map(res=>{         
               this.category.map(res1=>{             
                 if(res.categoryId==res1.id){
                   Object.assign(res1,{select:true})                
                 }
               })
            })
          }
        })
      }
      back(){
        if(this.url.includes('cotractorCategory')){
          this.router.navigate(['/vendorAdminProfile'])
        }else{
        this.router.navigate(['vendorProfile/',this.id])
        }
      }
      getId(id){
        this.catArray=[]
          this.category.map(res => {
          if (res.id == id) {
            res.select=!res.select
          }
        })   
       }
  
       route(){ 
         this.loader=true;
        this.array =  this.category.filter(res => { return res.select == true });       
          this.array.map(res=>{
          this.catArray.push({'userId': this.id,'categoryId':res.id})
        })             
             Object.assign(this.userObj,{categories:this.catArray})
          this.service.postProfileDetails(this.id,this.userObj).subscribe(res=>{
          this.handler.res('Profile Updated Successfully')
          this.loader=false;
          if(this.url.includes('cotractorCategory')){
            this.router.navigate(['/vendorAdminProfile'])
          }else{
          this.router.navigate(['vendorProfile/',this.id])
          }
         }, err => {
           this.loader=false;
          this.handler.err(err)
        }) 
       }

       ionViewWillLeave(){
        this.category = [];
        this.search = "";
       }
       clear(){
        this.search="";
      }
      ngDoCheck(): void {
        this.filterLength = sessionStorage.getItem('len')
      
      }
  }
  
